/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { JobWizardStore } from './job-wizard-store';

export const JobWizardStoreContext = createContext<JobWizardStore>({} as JobWizardStore);
